import "./index.css";
import React from "react";
import ReactDOM from "react-dom/client";
import { App } from "./App";
import { injectTrackingScript } from "./utils/tracking";

// Carga el seguimiento lo antes posible, antes de montar la página.
injectTrackingScript();
const rootEl = document.getElementById("root");
if (rootEl) {
  ReactDOM.createRoot(rootEl).render(<App data-id="element-625" data-mp="26alpwhjfajz2" />);
}